import { NavMenu } from "./NavMenu";

export function NavScheduling() {
  return <NavMenu area="scheduling" />;
}
